import { TextField, Box, Typography } from "@mui/material";
import MoedaInput from "../../../../util/ui/inputs/moedaInput";

type Props = {
  taxaOperacional: number;
  taxaRegistro: number;
  taxasBmf: number;
};

export default function CustosBmf({
  taxaOperacional,
  taxaRegistro,
  taxasBmf,
}: Props) {
  return (
    <Box
      display={"flex"}
      flexDirection="column"
      width="100%"
      paddingX={1}
      paddingY={2}
    >
      {/* Section header do sistema: eyebrow mono tracked sobre hairline. */}
      <Box
        borderBottom={1}
        borderColor="divider"
        paddingBottom={1}
        marginBottom={1.5}
      >
        <Typography variant="eyebrow" color="text.secondary">
          Custos BM&F
        </Typography>
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Taxa Operacional
          </Typography>
        </Box>

        <TextField
          id="standard-taxaOperacional"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={taxaOperacional}
          disabled={true}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Taxa de Registro
          </Typography>
        </Box>

        <TextField
          id="standard-taxaRegistro"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={taxaRegistro}
          disabled={true}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Taxas BM&F
          </Typography>
        </Box>

        <TextField
          id="standard-taxasBmf"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={taxasBmf}
          disabled={true}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
    </Box>
  );
}
